
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipe/[...alias]",
      function () {
        return require("private-next-pages/recipe/[...alias].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipe/[...alias]"])
      });
    }
  